import type { SilobagListItem } from '@siloreal:shared:api/service/silobag/silobag-list';
import UTILS from './utils';

export type ClosureBlockReason = 'closed' | 'not-found' | 'permission' | 'vrr';

export type BlockedSilobag = {
  id: string;
  name: string;
  reasons: ClosureBlockReason[];
};

export type SilobagClosureAnalysis = {
  blocked: BlockedSilobag[];
  closable: SilobagListItem[];
};

export function analyzeSilobagsForClosure(
  requestedIds: readonly string[],
  rows: readonly SilobagListItem[],
  options: { blockVrr?: boolean } = {}
): SilobagClosureAnalysis {
  const { blockVrr = true } = options;
  const rowById = new Map(rows.map((row) => [String(row.id), row]));
  const blocked: BlockedSilobag[] = [];
  const closable: SilobagListItem[] = [];

  requestedIds.forEach((id) => {
    const row = rowById.get(id);

    if (!row) {
      blocked.push({ id, name: id, reasons: ['not-found'] });
      return;
    }

    const reasons: ClosureBlockReason[] = [];
    if (!row.write_permission) reasons.push('permission');
    if (!row.active) reasons.push('closed');
    if (
      blockVrr &&
      row.tags_silobags?.some(
        ({ tag }) => tag.scope.value === 'system' && (UTILS.is.vrr.ok(tag) || UTILS.is.vrr.not_ok(tag))
      )
    ) {
      reasons.push('vrr');
    }

    if (reasons.length > 0) {
      blocked.push({ id, name: row.name, reasons });
      return;
    }

    closable.push(row);
  });

  return { blocked, closable };
}
